// src/components/AboutUs.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaStore, FaUsers, FaAward } from 'react-icons/fa';

const AboutUs = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <Link 
        to="/" 
        className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
      >
        <FaArrowLeft /> Back to Home
      </Link>

      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        {/* Hero Section */}
        <div className="bg-green-600 text-white py-16 text-center">
          <FaStore className="text-5xl mx-auto mb-4" />
          <h1 className="text-4xl font-bold mb-4">About FreshMart Groceries</h1>
          <p className="text-xl opacity-90">Your trusted partner for fresh groceries since 2020</p>
        </div>

        <div className="p-8">
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Story</h2>
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  FreshMart started with a simple mission: to bring fresh, high-quality groceries 
                  right to your doorstep. What began as a small local store has grown into 
                  a trusted online grocery platform serving thousands of happy customers.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed">
                  We believe everyone deserves access to fresh, affordable groceries without 
                  the hassle of crowded stores. Our team works tirelessly to ensure that 
                  every product meets our strict quality standards.
                </p>
              </div>
              <div className="bg-green-100 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-green-800 mb-4">Why Choose Us?</h3>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3">
                    <FaAward className="text-green-600" />
                    <span>100% Quality Guarantee</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <FaUsers className="text-green-600" />
                    <span>24/7 Customer Support</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <FaStore className="text-green-600" />
                    <span>Wide Product Selection</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Values</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center p-6 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-green-600 font-bold">Q</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">Quality</h3>
                <p className="text-gray-600">We never compromise on the quality of our products</p>
              </div>
              
              <div className="text-center p-6 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-green-600 font-bold">T</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">Trust</h3>
                <p className="text-gray-600">Building lasting relationships with our customers</p>
              </div>
              
              <div className="text-center p-6 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-green-600 font-bold">I</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">Innovation</h3>
                <p className="text-gray-600">Constantly improving our services and technology</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;